import React from 'react';
import GlobalFooter from './sections/GlobalFooter';
import { GLOBAL_FOOTER_1_QUERY, GLOBAL_FOOTER_2_QUERY } from '../context/context';
import { useContentfulEntry } from '../hooks/useContentfulEntry';

function Footer() {
  const { entry: footer1, loading: loading1, error: error1 } = useContentfulEntry(GLOBAL_FOOTER_1_QUERY);
  const { entry: footer2, loading: loading2, error: error2 } = useContentfulEntry(GLOBAL_FOOTER_2_QUERY);

  // Loading or error states
  if (loading1 || loading2) return null;
  if (error1 || error2) return null;

  // Extract and merge items arrays from both footers
  const items1 = footer1?.items?.[0]?.fields?.items || [];
  const items2 = footer2?.items?.[0]?.fields?.items || [];

  const mergedItems = [...items1, ...items2];

  if (mergedItems.length === 0) return null;

  return (
    <div id='footer'>
      <GlobalFooter entries={mergedItems} />
    </div>
  );
}

export default Footer;
